/** Tracks one outstanding application heartbeat and detects silent WebSocket loss. */
export class RealtimeHeartbeatWatchdog {
  private pendingSince: number | null = null;

  public constructor(
    private readonly responseDeadlineMs: number,
    private readonly now: () => number = () => Date.now(),
  ) {}

  /** Records a probe while preserving the oldest unanswered probe deadline. */
  public recordPing(): boolean {
    const current = this.now();
    if (this.pendingSince === null) {
      this.pendingSince = current;
      return true;
    }
    return current - this.pendingSince < this.responseDeadlineMs;
  }

  public recordPong(): void {
    this.pendingSince = null;
  }

  public reset(): void {
    this.pendingSince = null;
  }
}
